import {content} from './content'
import {meta} from './meta'
import {options} from './options'
import type {GroupReturn} from '../types'

export * from './define'
export * from './group'

export const fieldGroupDefaults = (): GroupReturn[] => [content(), meta()]
export const fieldGroupComponentOptions = (): GroupReturn[] => [content(), options()]
export {content, meta, options}
